module.exports = __webpack_public_path__ + "static/media/long-arrow-left.2716e12f.svg";